<template>
    <UserTable v-bind:extended-columns="true" v-bind:can-delete="true"></UserTable>
</template>

<script>
import UserTable from '@/app/admin/users/shared/components/userTable';

export default {
  name: 'UserList',
  components: {
    UserTable,
  },
  data() {
    return {};
  },
};
</script>

<style>

</style>
